// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__P12pR","disabled":"styles_disabled__VDF-1"};